import { GridPricing, Product } from '@setvi/shared/interfaces';
import { Loader } from './components';
import { FullContent } from './components/full-content';

interface FullPriceProps {
  product: Product;
  loading: boolean;
  pricing: GridPricing[];
}

export const FullPrice = ({ product, pricing, loading }: FullPriceProps) => {
  if (loading) return <Loader />;

  return <FullContent product={product} pricing={pricing} />;
};
